// extracted by mini-css-extract-plugin
export default {"root":"ToastContainer_root__RFyQ0","pos-bottom":"ToastContainer_pos-bottom__2YVQ0"};